export default {
    400: {
        title: "Ungültige Anforderung",
        header: "@:views.errors.400.title",
        html: "Fehlerhafte Anfrage. Bitte versuchen Sie es später erneut."
    },
    401: {
        title: "Beim Anmelden ist ein Fehler aufgetreten.",
        header: "@:views.errors.401.title",
        html: "Bitte wenden Sie sich an <a href='{email}' target='_blank'>den Support</a> ."
    },
    404: {
        title: "Seite nicht gefunden",
        header: "@:views.errors.404.title"
    },
    403: {
        title: "Zutritt nicht gestattet",
        header: "Zutritt nicht gestattet",

        contact: "O-I Peripheriegeräte stehen nur Mitarbeitern zur Verfügung. Wenn Sie Mitarbeiter sind und diese Nachricht sehen, wenden Sie sich bitte an Ihre Personalabteilung, um Ihren Status zu aktualisieren.",

        subject: "Ausrüstung - Teilnahmeberechtigung",

        html: "<p class='text-start'> @:views.errors.403.contact</p>",
        error: {
            disabled: {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Sie sind derzeit nicht teilnahmeberechtigt. Bitte kontaktieren Sie <a href='#' role='button' data-widget-trigger='{widgetOptions}'>den Support</a> für weitere Informationen.</p>"
            },
            "not-active": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Sie sind derzeit nicht teilnahmeberechtigt. Bitte wenden Sie sich für weitere Informationen an Ihre örtliche Personal- und Kulturabteilung.</p>"
            },
            "not-allowed":{
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>O-I Peripheriegeräte stehen nur Mitarbeitern zur Verfügung. Wenn Sie Mitarbeiter sind und diese Nachricht sehen, wenden Sie sich bitte an Ihre Personalabteilung, um Ihren Status zu aktualisieren.</p>"
            },
            "no-manager": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>In Ihrem ServiceNow-Profil ist kein aktiver Vorgesetzter hinterlegt. Bitte wenden Sie sich an Ihren zuständigen Personalverantwortlichen, um Ihre Vorgesetztendaten zu aktualisieren.</p>"
            },
            "self-manager": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>In Ihrem ServiceNow-Profil ist Ihre Führungskraft als solche hinterlegt. Bitte wenden Sie sich an Ihren zuständigen Personalverantwortlichen, um Ihre Führungskraft zu aktualisieren.</p>"
            },
            "no-location": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>In Ihrem ServiceNow-Profil ist kein Standort angegeben. Bitte wenden Sie sich an Ihren zuständigen Personalverantwortlichen, um Ihren Standort zu aktualisieren.</p>"
            },
            eligibility: {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>O-I Peripheriegeräte stehen nur Mitarbeitern zur Verfügung. Wenn Sie Mitarbeiter sind und diese Nachricht sehen, wenden Sie sich bitte an Ihre Personalabteilung, um Ihren Status zu aktualisieren.</p>",
            },
            "eligibility-location": {
                header: "",
                html: "Vielen Dank für Ihr Interesse an O-I Peripheral. Dieses Programm ist derzeit in Ihrem Land nicht verfügbar.",
            },
            "secondary-account": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Sie versuchen derzeit, mit einem Zweitkonto auf O-I Peripheral zuzugreifen. Bitte melden Sie sich mit Ihrem Hauptkonto erneut an.</p>"
            },
            "empty-core-id": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Ihr ServiceNow-Konto hat keinen Kontonamen. Bitte wenden Sie sich an Ihren zuständigen Personalreferenten, um Ihr Konto zu aktualisieren.</p>"
            },
            country: {
                header: "@:views.errors.403.header",
                html: " @:views.errors.403.contact",
            },
            "no-permissions": {
                header: "Kein Zugriff",
                subject: "Kein Zugriff",
                html: "Sie haben keine Berechtigung, diese Seite zu öffnen.",
            },
            "virtual-denied": {
                header: "Sie scheinen etwas zu früh dran zu sein...",
                html: "<p class='text-start'>Vielen Dank für Ihr Interesse an O-I Peripheral. Sie haben die Website anscheinend aufgerufen, bevor Sie freigeschaltet und direkt eingeladen wurden. O-I Peripheral wird schrittweise, länderweise und für verschiedene Nutzergruppen eingeführt. Nach Ihrer Freischaltung erhalten Sie eine E-Mail mit einer persönlichen Einladung und weiteren Anweisungen.</p><p class='text-start'> Klicken Sie auf <a href='#' role='button' data-widget-trigger='{widgetOptions}'>„Support“</a> , wenn Sie Fragen oder Probleme mit Ihrer Bestellung oder der Website haben.</p>",
            }
        }
    },
    500: {
        title: "Unerwarteter Fehler",
        header: "@:views.errors.500.title",
        message: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut."
    },
    code: {
        title: "Unerwarteter Fehler",
        message: "@:views.errors.code.title",
        error: "Fehler {code}."
    }
}